export function LoadingScreen() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="w-8 h-8 border-[3px] border-tg-hint/30 border-t-tg-hint rounded-full animate-spin" />
    </div>
  );
}
